import { BaseResponse } from 'domain/payload/response/BaseResponseDto';
import axiosInstance from '../../config/AxiosConfig'
import { ProjectKeyListResp } from 'domain/payload/response/clientTransmora/projectKey/ProjectKeyListResp';
import { ProjectKeyDetailResp } from 'domain/payload/response/clientTransmora/projectKey/ProjectKeyDetailResp';
import { ProjectKeySaveReq } from 'domain/payload/request/clientTransmora/projectKey/ProjectKeySaveReq';
import { ProjectKeyConfigResp } from 'domain/payload/response/clientTransmora/projectKey/ProjectKeyConfigResp';

const ProjectKeyService = () => {
  const ProjectKeyList = async (
    token: string,
    search: string | null,
    page: number | null,
    size: number | null
  ): Promise<BaseResponse<ProjectKeyListResp[]>> => {
    try {
      const response = await axiosInstance.get(`/v1/legacy/cms/client-project-key/list`, {
        headers: {
          Authorization: `Bearer ${token}`
        },
        params: {
          search: search,
          page: page,
          size: size
        }
      });

      return response.data

    } catch (error: any) {
      throw error.response.data.message;
    }
  };

  const ProjectKeyDetail = async (
    token: string,
    id: string
  ): Promise<BaseResponse<ProjectKeyDetailResp>> => {
    try {
      const response = await axiosInstance.get(`/v1/legacy/cms/client-project-key/detail?id=${id}`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      return response.data

    } catch (error: any) {
      throw error.response.data.message;
    }
  };

  const ProjectKeySave = async (
    token: string,
    request: ProjectKeySaveReq
  ): Promise<BaseResponse<ProjectKeyDetailResp>> => {
    try {
      const response = await axiosInstance.post(`/v1/legacy/cms/client-project-key/save`, request, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      return response.data

    } catch (error: any) {
      throw error.response.data.message;
    }
  };

  const ProjectKeyConfig = async (
    token: string
    ): Promise<ProjectKeyConfigResp> => {
    try {
        const response = await axiosInstance.get(`/v1/legacy/cms/client-project-key/config`, {
        headers: {
            Authorization: `Bearer ${token}`
        }
        });

        return response.data;

    } catch (error: any) {
        throw error.response.data.message;
    }
  };

  const ProjectKeyDelete = async (
    token: string,
    id: string
  ): Promise<BaseResponse<any>> => {
    try {
      const response = await axiosInstance.delete(
        `/v1/legacy/cms/client-project-key/delete`,
        {
          headers: { Authorization: `Bearer ${token}` },
          params: { id },
        }
      );
      return response.data;
    } catch (error: any) {
      throw error.response?.data?.message || error.message;
    }
  };

  return { ProjectKeyList, ProjectKeyDetail, ProjectKeySave, ProjectKeyConfig, ProjectKeyDelete, /* ProjectKeyExecute */ };
};

export default ProjectKeyService;